import { VariantColor } from '@repo/toolkit/colors'

export const getDpaeDisplayStatus = (
  dpaeDownloadAt?: string,
  dpaeFilledAt?: string
): {
  variant: VariantColor
  label: string
} => {
  if (dpaeFilledAt) {
    return { variant: 'success', label: 'Rempli' }
  }

  if (dpaeDownloadAt) {
    return { variant: 'danger', label: 'Envoyé' }
  }

  return { variant: 'warning', label: 'En attente' }
}
